import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin, map } from 'rxjs';
import { IPortalConfig } from '../models';
import { AuthorizationService, CoreService, LoaderService, PortalService } from '../services';

@Injectable({ providedIn: 'root' })
export class PotalAuthorizeGuard  {
  constructor(
    private router: Router,
    private coreService: CoreService, private loaderService: LoaderService, private portalService: PortalService,
    private authorizationService: AuthorizationService
  ) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise(res => {
      this.loaderService.showLoader();
      let sponsorName = <string>route.paramMap.get('Sponsor');
      let portalName = <string>route.paramMap.get('Portal');
      this.coreService.getUserPortalInfo(sponsorName, portalName).then(
        (portalInfo: IPortalConfig) => {
          if (portalInfo == null || portalInfo == undefined) {
            this.loaderService.hideLoader();
            this.router.navigateByUrl("/Error/Forbidden");
            res(false);
          }
          else {
            const Tools = this.coreService.getUserToolNavigation(<string>portalInfo.SponsorName, <number>portalInfo.PortalID);
            const FeatureNavigation = this.coreService.getUserFeatureNavigation(<string>portalInfo.SponsorName, <number>portalInfo.PortalID);
            const allFeatures = this.coreService.getAllUserFeatures(<string>portalInfo.SponsorName, <number>portalInfo.PortalID);
            const userPortals = this.coreService.getUserPortals();

            userPortals.then((allPortals: Array<any>) => {
              this.portalService.setUserPortalsSubject(allPortals);
              if (this.authorizationService.isPortalAllowed(sponsorName, portalName)) {
                forkJoin(Tools, FeatureNavigation, allFeatures).pipe(map((allResponses) => {
                  this.portalService.setPortalDisplayName(portalInfo.DisplayName!);
                  this.portalService.setPortalConfigSubject(portalInfo);
                  this.portalService.setToolsMenuSubject(allResponses[0]);
                  this.portalService.setNavigationMenuSubject(allResponses[1]);
                  this.portalService.setAllFeaturesSubject(allResponses[2]);
                  this.loaderService.hideLoader();
                  res(true);
                })).toPromise();
              } else {
                this.loaderService.hideLoader();
                this.router.navigateByUrl("/Error/Forbidden");
                res(false);
              }
            });
          }
        }, (reject: any) => {
          if (reject.status != 401) {
            this.loaderService.hideLoader();
            this.router.navigateByUrl("/Error/Forbidden");
          }
          res(false);
        }).catch((error) => {
          this.loaderService.hideLoader();
          this.router.navigateByUrl("/Error/ServerError");
          res(false);
        }).finally(() => {
          //this.loaderService.hideLoader();
        });
    });
  }
}
